module.exports = __webpack_public_path__ + "static/img/s1.0ce05a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/market/market102/s1.png
// module id = 5OzS
// module chunks = 1